import { CollaborativeItem } from '@mygpt/app/collaborate/services/get-collaborative-list';
import { Http, PageData, PageQuery } from '@mygpt/app/http';
import { User } from '@mygpt/app/users/services/get-enterprise-plan-list';

export interface MembersItem {
  id: string;
  created_at: string;
  resource_id: string;
  resource_type: string;
  member: User;
}

export interface AiInfoItemWithMembers {
  ai: CollaborativeItem;
  members: MembersItem[];
}

/**
 * 获取机器人列表（带协作者信息）
 * @param params
 * @returns
 */
export const getRobotListWithMembers = (params: PageQuery) => {
  const { get } = Http.use();
  return get<PageData<AiInfoItemWithMembers>>(`/ais/members`, {
    params,
  });
};
